import React from 'react';
import { Container, Col, Row } from 'reactstrap';
import ToolsManageSellersPage from './components/ToolsManageSellersPage';

const ToolsManageSellers = () => (
  <Container>
    <Row>
      <Col md={12}>
        <h5 className="page-title">Tools / Sellers / Manage</h5>
      </Col>
    </Row>
    <Row>
      <ToolsManageSellersPage />
    </Row>
  </Container>
);

export default ToolsManageSellers;
